import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import { notEmpty } from "../../../utils/not-empty";
import {
  type MomentFormSurvey,
  SupabaseMomentFormSurveyService,
} from "../server/supabase-survey-service";
import { buildStatusFilter } from "./common";
import type { UseSurveyConfig } from "./types";

export function useMomentFormSurveys(
  config: UseSurveyConfig = {},
): UseSupabaseLoaderState<MomentFormSurvey[]> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const filter = [buildStatusFilter(config.allowedStatuses)].filter(notEmpty);

      const { data, error } = await new SupabaseMomentFormSurveyService(supabase).getAll(
        account_id,
        {
          order: [{ column: "created_at", dir: "desc" }],
          filter,
        },
      );

      if (error) {
        throw new Error(`Failed to load moment_form_surveys: ${error.message}`);
      }

      return data;
    },
    [config.allowedStatuses],
  );
}
